// extracted by mini-css-extract-plugin
module.exports = {"two-columns":"Content_two-columns__g9gp8","two-columns-content":"Content_two-columns-content__WOTh_","content":"Content_content__Ya8DL","quote-icon":"Content_quote-icon___xZl3"};